<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Fabric_Title' | translateWF: 'Fabric' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="goToDetails('new')" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'Fabric_Title' | translateWF: 'Fabric'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>

          <p-card data-variant="compact">
            <p-table [value]="listFabrics()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
              <ng-template pTemplate="header">
                <tr class="primary__header">
                  <th pSortableColumn="fabricCode">
                    {{ 'Fabric_Code' | translateWF: 'Code' }}
                    <p-sortIcon field="fabricCode" />
                  </th>
                  <th pSortableColumn="longDescription">
                    {{ 'Fabric_Description' | translateWF: 'Description' }}
                    <p-sortIcon field="longDescription" />
                  </th>
                  <th>
                    {{ 'Fabric_Type' | translateWF: 'Type' }}
                  </th>
                  <th>
                    {{ 'Fabric_Status' | translateWF: 'Status' }}
                  </th>
                  <th>
                    {{ 'Fabric_Brand' | translateWF: 'Brand' }}
                  </th>
                  <th>
                    {{ 'Fabric_Customer' | translateWF: 'Customer' }}
                  </th>
                  <th></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                @let fabric = getRowData(rowData);
                <tr (click)="goToDetails(fabric.id)">
                  <td class="truncate">
                    <a>
                      {{ fabric.fabricCode }}
                    </a>
                  </td>
                  <td>
                    {{ fabric.longDescription }}
                  </td>
                  <td class="truncate">
                    {{ fabric.fabricTypeCode }}
                  </td>
                  <td class="truncate">
                    {{ statuses()[fabric.status] | pascalToNormalCase }}
                  </td>
                  <td class="truncate max-w-[7.5rem]">
                    {{ fabric.brandReference ? (getBrand(fabric.brandReference)?.name ?? 'Loading...') : 'N/A' }}
                  </td>
                  <td class="truncate max-w-[7.5rem]">
                    {{ getCustomer(fabric.customerReference)?.name ?? 'Loading...' }}
                  </td>
                  <td class="!text-end">
                    <p-button icon="pi pi-trash" variant="outlined" [disabled]="!canDelete(fabric)" (click)="deletePopup($event, fabric)" />
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">
                    {{ 'Fabric_Not_Found' | translateWF: 'Fabrics not found' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <p-paginator
              [rows]="pageSize()"
              [totalRecords]="totalRecords()"
              [first]="(currentPage() - 1) * pageSize()"
              (onPageChange)="onPageChange($event)"
              [rowsPerPageOptions]="[15, 25, 50]"
              class="mt-4"
            />
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
  <p-confirmdialog key="deleteFabric" />
</main>
